import React, { useState,useRef,useEffect } from "react";
import { formatToLocalDateTime } from "../utils/formatDate";
import Loader from "../../../components/Loader";
import { CustomModal } from "./CustomModal";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import { deleteMedia } from "../api/media";
import eye from "../../../assets/eye.svg";

interface OfferTableProps {
  tableData: any;
  loading: boolean;
  refetch: boolean;
  setRefetch: React.Dispatch<React.SetStateAction<boolean>>;
}

const MediaTable: React.FC<OfferTableProps> = ({
  tableData,
  loading,
  refetch,
  setRefetch,
}) => {
  const [menuOpen, setMenuOpen] = useState<number | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState<number | null>(null);

  const toggleMenu = (index: number) => {
    if (index) setMenuOpen(index);
  };
  const navigate = useNavigate();

  const handleModalActivity = () => {
    setIsOpen(!isOpen);
  };

  const handleEditMedia = () => {
    if (menuOpen === null) return;
    navigate(URL_MAPPING.EDITMEDIA(String(menuOpen)));
  };

  const handleDeleteMedia = async () => {
    try {
      if (selectedItemId  === null) {
        toast.error("No medias selected for deletion");
        return;
      }
      const response = await deleteMedia(selectedItemId );
      if (!response) {
        toast.error("No data received or malformed response");
        console.warn("No data received or malformed response:", response);
        return;
      }
      toast.success("Media deleted successfully");
      handleModalActivity();
      setRefetch(!refetch);
    } catch (error: any) {
      console.error("Failed to fetch media data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later");
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching the employee");
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.");
        }
      }
    }
  };

  const dropdownRef = useRef<HTMLDivElement | null>(null);
   useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
          setMenuOpen(null); // Close menu
        }
      };
    
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
  return (
    <>
      <ToastContainer />
      <CustomModal
        isOpen={isOpen}
        onClose={handleModalActivity}
        onDelete={handleDeleteMedia}
      />
      <div className="h-[calc(100vh-200px)] md:h-[calc(100vh-200px)] overflow-auto page-container p-2 pt-0 scrollbar scrollbar-thin">
        <table className="min-w-full bg-white border border-black-200 table-auto border-separate border-spacing-0">
          <thead className="bg-gray-200 sticky top-[0px] z-20">
            <tr>
              <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-nowrap">
                ID
              </th>
              <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
                File Name
              </th>
              <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 w-24">
                File Type
              </th>
              <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                File Path
              </th>
              <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
                Created At
              </th>
              <th className="border border-gray-300 text-13 font-bold text-black-500 whitespace-nowrap px-2 py-2 w-1">
                Actions
              </th>
            </tr>
          </thead>
          {loading ? (
            <tbody>
              <tr>
                <td colSpan={16} className="py-8">
                  <div className="flex justify-center items-center w-full">
                    <Loader />
                  </div>
                </td>
              </tr>
            </tbody>
          ) : !loading && tableData?.items?.length === 0 ? (
            <tr>
              <td colSpan={16} className="py-8 text-center text-gray-500">
                No results found
              </td>
            </tr>
          ) : (
            <tbody>
              {Array.isArray(tableData?.items) &&
                tableData.items.map((item: any, index: number) => (
                  <tr key={index} className="border-b text-sm">
                    <td className="border border-gray-300 px-4 py-2">{item.id || "-"}</td>
                    <td className="border border-gray-300 px-4 py-2">{item.file_name || "-"}</td>
                    <td className="border border-gray-300 px-4 py-2">{item.file_type || "-"}</td>
                    <td className="border border-gray-300 px-4 py-2">
                      {item.file_url ? (
                        <a
                        href={`https://${item.file_url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex justify-center items-center"
                        >
                      <img className="w-4 h-4" src={eye} alt="view" />
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {formatToLocalDateTime(item.created_at) || "-"}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-center relative">
                      <button
                        onClick={() => toggleMenu(item.id)}
                        className="text-gray-500 hover:text-gray-800"
                      >
                        <p className="text-lg">⋮</p>
                      </button>
                      {menuOpen === item.id && (
                        <div
                        ref={dropdownRef}
                          className={`absolute right-10 -mt-5 w-32 bg-white border border-gray-200 shadow-lg rounded z-10 text-left`}
                        >
                          <ul className="py-1 text-sm text-gray-900">
                            {/* <li
                              className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                              onClick={() => handleEditMedia()}
                            >
                              Edit
                            </li> */}
                            <li
                              className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                              onClick={() => {
                                setSelectedItemId(item.id);  // set for modal
                                handleModalActivity();
                              }}
                            >
                              Delete
                            </li>
                          </ul>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          )}
        </table>
      </div>
    </>
  );
};

export default MediaTable;
